<template>
    <div>
      <el-card class="box-card" style="margin: 30px; padding: 20px;">
        <div style="display: flex;">
          <div style="width: 420px;">
            <div style="min-height: 800px; border-radius: 10px; border: 1px solid #ccc;">
              <el-carousel height="200px" indicator-position="outside">
                <el-carousel-item v-for="item in branddata" :key="item">
                  <div @click="showlink(item)" style="height:100%; width:100%;">
                    <el-image
                      :src="item.adurl"
                      style="height:100%; width:100%;"
                      fit="cover"></el-image>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div style="flex: 1;margin: 0 20px 0 20px;">
            <div class="pcenter" style="margin-left: 20px; justify-content: flex-start; flex-flow: row wrap;">
              <el-select v-model="brandpos" style="margin-top: 10px; margin-right: 10px;" filterable placeholder="请选择轮播图位置">
                <el-option
                  v-for="item in brandposlist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <div style="margin-top: 10px;">
                <el-button type="primary" icon="el-icon-plus" @click="addbrand">添加轮播图</el-button>
              </div>
            </div>
            <div style="display: flex; width: 95%; padding: 20px; justify-content: center;">
              <el-table
                stripe
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="branddata"
                ref="multipleTable">
                <el-table-column
                  prop="tjindex"
                  width="80px"
                  label="次序">
                </el-table-column>
                <el-table-column
                  label="轮播图图片">
                  <template slot-scope="scope">
                    <div v-if="scope.row.adurl">
                      <img :src="scope.row.adurl" class="avatarimg6">
                    </div>
                    <div v-else>
                      {scope.row.adurl}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="80px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="编辑该轮播图" placement="top-start">
                      <i class="fa el-icon-edit-outline fa-lg opicon curpointer" v-on:click="editlbt(scope.$index, branddata)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除该轮播图" placement="top-start">
                      <i style="margin-left: 15px; color: darkred" class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="dellbt(scope.$index, branddata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-card>
      <el-dialog title="资料信息" :visible.sync="vis_addbrandpanel">
        <div >
          <el-form  label-width="120px">
            <el-row >
              <el-col :span="24">
                <el-form-item label="轮播图位置：">
                  <el-select v-model="brandpos" filterable placeholder="请选择轮播图位置">
                    <el-option
                      v-for="item in brandposlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="display: flex;flex-flow: row wrap;">
              <el-form-item label="上传轮播图：" class="yyzz_upload" style="width:380px;">
                <UpLoadFile ref="upfile" @upok="upok" :ifshowfile="ifshowfile" :ifupload="ifupload" :ifimg="ifimg" :curfilepath="curfilepath" :bucketpath="bucketpath"></UpLoadFile>
              </el-form-item>
              <div style="flex:1;min-width: 280px;">
                <el-collapse v-model="scactive" accordion>
                  <el-collapse-item title="上传说明" name="1">
                    <div>1、您可以上传任何类型的资料。</div>
                    <div>2、上传前一定要看好上传的路径！</div>
                    <div>3、上传时，上传文件下方会有上传进度。</div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
            <el-row>
              <el-col style="margin-top: 10px;">
                <el-form-item label="轮播图地址：" class="yyzz_upload">
                  <el-input v-model="address_lbt" placeholder="自动获取轮播图地址"></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="显示次序：" class="yyzz_upload">
                  <el-input v-model="lbttjindex" placeholder="显示次序"></el-input>
                </el-form-item>
              </el-col>
              <el-col style="margin-bottom: 2rem;margin-top: 2rem;">
                <el-radio-group v-model="radiovalue" v-on:change="linkchange">
                  <el-radio label="1">暂无链接</el-radio>
                  <el-radio label="2">存在链接</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row v-if="showlbtlink">
              <el-tabs v-model="lbt_link">
                <el-tab-pane label="视频" name="tab_video">
                  <div style="display: flex;flex-flow: row wrap;">
                    <el-form-item label="上传轮播图：" class="yyzz_upload" style="width:380px;">
                      <UpLoadFile ref="upfile" @upok="upok1" :ifshowfile="ifshowfile" :ifupload="ifupload" :ifimgvideo="ifimg" :curfilepath="curfilepath" :bucketpath="bucketpath"></UpLoadFile>
                    </el-form-item>
                    <div style="flex:1;min-width: 280px;">
                      <el-collapse v-model="scactive" accordion>
                        <el-collapse-item title="上传说明" name="1">
                          <div>1、您可以上传任何类型的资料。</div>
                          <div>2、上传前一定要看好上传的路径！</div>
                          <div>3、上传时，上传文件下方会有上传进度。</div>
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </div>
                  <el-row>
                    <el-form-item label="视频地址：" class="yyzz_upload" style="margin-top: 10px;">
                      <el-input v-model="address_video" placeholder="视频地址"></el-input>
                    </el-form-item>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="商品分类" name="tab_goodstype">
                  <el-row style="margin-bottom: 20px;">
                    <el-tree
                      :data="gtypedatas"
                      ref="gt_tree_list"
                      highlight-current
                      @current-change="typechange"
                      current-node-key="id"
                      node-key="id"
                      :check-strictly = "true"
                      :expand-on-click-node="false"
                      default-expand-all
                      :render-content="renderugcontext"
                    />
                  </el-row>
                  <el-row>
                    <el-form-item label="当前选取分类：" class="yyzz_upload">
                      <el-input v-model="select_type" placeholder="所选分类"></el-input>
                    </el-form-item>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="H5页面" name="tab_h5page">
                  <el-row>
                    <el-form-item label="H5页面：" class="yyzz_upload">
                      <el-input v-model="address_h5" placeholder="H5链接地址"></el-input>
                    </el-form-item>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </el-row>
            <el-row>
              <el-button @click="savelbtinfo">保存轮播图</el-button>
            </el-row>
          </el-form>
        </div>
      </el-dialog>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import '../../../static/css/my.css'
  import * as Quill from 'quill'
  import Utils from '../../util/utils'
  import Video from '../../util/video'
  import UpLoadFile from '../upload/UpLoadFile'
  var OSS = require('ali-oss')
  Quill.register(Video, true)
  Vue.prototype.$http = axios
  var that
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{'header': 1}, {'header': 2}],
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{ script: 'sub' }, { script: 'super' }],
    [{'indent': '-1'}, {'indent': '+1'}],
    [{'direction': 'rtl'}],
    [{'size': ['small', false, 'large', 'huge']}],
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],
    [{'font': []}],
    [{'align': []}],
    ['link', 'image', 'video'],
    ['clean']
  ]
  export default {
    name: 'BrandSet',
    components: {
      UpLoadFile
    },
    data () {
      return {
        lbt_link: 'tab_video',
        brandpos: '1',
        address_lbt: '',
        address_video: '',
        select_type: '',
        contactus: '',
        bucketpath: 'ecomm/brands',
        address_video_mainpage: '',
        selectuppathtitle: '',
        radiovalue: '1',
        gtypedatas: [], // 分类的基础数据
        ifshowfile:false, // 上传页面参数： 是否显示文件
        curfilepath: '', // 上传页面参数： 当前选中图标文件路径
        ifimg: true, // 上传页面参数： 上传方式是否设定为 图片模式
        ifimg1: false, // 上传页面参数： 上传方式是否设定为 图片模式
        ifupload: true, // 上传页面参数： 是否显示上传参数
        activeName: 0,
        uploadHeaders: {
          authorization: ''
        },
        lbttjindex: 0,
        address_h5: '',
        address_type: '',
        address_typen: '',
        files: 100,
        address_type_img: '',
        visupfilepanel: false,
        editorOption: {},
        ifnewtjtype: false,
        ifnewtjgoods: false,
        ifnewbrand: false,
        edittjtypedata: '',
        edittjgoodsdata: '',
        editbranddata: '',
        lc_typename: '',
        lc_typedes: '',
        lc_linkname: '',
        lc_tjindex: 0,
        brandposlist: [{
          value: '0',
          label: '所有类型'
        }, {
          value: '1',
          label: '顶部'
        }, {
          value: '2',
          label: '中间'
        }, {
          value: '3',
          label: '底部'
        }],
        ifrecdata: [{
          value: '1',
          label: '推荐'
        }, {
          value: '2',
          label: '不推荐'
        }],
        iffzsyinfo: '1',
        iffzsy: [{
          value: '1',
          label: '放置'
        }, {
          value: '2',
          label: '不放置'
        }],
        tjindex: '',
        scactive: '1',
        shortcut: '',
        showlbtlink: false,
        vislztpanel: false,
        branddata: [],
        tjspdata: [],
        kjrkdata: [],
        lztdata: [],
        goodstypedata: [],
        cusgoodsdata: [],
        ifrecinfo: '1',
        vis_addbrandpanel: false,
        vis_addshortcutpanel: false,
        vis_addtjgoodspanel: false,
        vis_addtypepanel: false,
        uplbtparams: '',
        upshortcutparams: '',
        ztparams: '',
        ztimg: '',
        zttitle: '',
        ztsubtitle: '',
        selectpath: '',
        ztdes: '',
        selecttype: '',
        fzindex: '',
        shortcutpath: '',
        upvideos: '',
        custjtypedata: [],
        custjcoursedata: [], /// 推荐分类数据
        vis_addtjcoursepanel: false, /// 是否显示分类面板
        ifnewcoursetype: false,
        cuscoursedata: [],
        brandimgs: []
      }
    },
    created: function () {
      this.editorOption =
        {
          uploadConfig: {
            methods: 'POST',
            res: (respnse) => {
              console.log(respnse)
              return respnse.info
            }
          },
          methods: 'POST',
          size: 5100,
          accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',
          // input点击事件  formData是提交的表单实体
          change: (formData) => {
          },
          // 设置请求头 xhr: 异步请求， formData: 表单对象
          header: (xhr, formData) => {
            // xhr.setRequestHeader('myHeader','myValue');
            // formData.append('token', '1234')
          },
          // start: function (){}
          start: () => {
          },
          end: () => {
          },
          success: () => {
            console.log('上传成功')
          },
          error: () => {
          },
          placeholder: '请在此输入内容',
          theme: 'snow',
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                'image': function (value) {
                  that.visupfilepanel = true
                  that.selectuppathtitle = '上传图片'
                  that.upfiletype = 'image'
                },
                'video': function (value) {
                  that.visupfilepanel = true
                  that.selectuppathtitle = '上传视频'
                  that.upfiletype = 'video'
                }
              }
            }
          }
        }
    },
    mounted: function () {
      that = this
      var v = getCookie('cusid')
      this.khid = v
      that.selectpath = 'others/'
      this.uplbtparams = {
        bucketname: 'wyzb1',
        bucketpath: 'brands/admin'
      }
      that.querybrand()
      that.get_typedata()
    },
    methods: {
      typechange (node) {
        window.console.log(node)
        that.select_type = node.name
        that.selecttype = node.id
      },
      renderugcontext (h, { node, data, store }) {
        return (
          <div style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <div style="display: flex; flex-direction: row; align-items: center; height: 45px; width:100%; border-bottom:1px solid #f3f3f3;justify-content: space-between;">
          <div>
          {
          <span> {data.name} </span>
      }
      </div>
        </div>

        </div>
      )
      },
      get_typedata () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('username') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/quergtype',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.length > 0) {
              that.gtypedatas = JSON.parse(res.data[0].typetree)[0].children
            } else {
              that.gtypedatas = []
              var adata = {
                id: 0,
                name: '默认类别',
                imgurl: '',
                children: []
              }
              that.gtypedatas.push(adata)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      showlink (item) {
        if (item.linktype === 4 || item.linktype === 2) {
          window.open(item.hurl)
        }
      },
      upok (curpath,fileList) {
        that.address_lbt = curpath
        that.brandimgs = fileList
      },
      upok1 (curpath,fileList) {
        window.console.log(fileList)
        that.address_video = curpath
      },
      addbrand () {
        this.ifnewbrand = true
        this.vis_addbrandpanel = true
        this.radiovalue = '1'
        this.address_lbt = ''
        this.address_video = ''
        this.address_type_img = ''
        this.address_h5 = ''
      },
      /* 获取轮播图 */
      querybrand () {
        that = this
        if (that.khid === null) {
          that.$message({
            type: 'info',
            message: 'Cookie已失效，请重新登录!'
          })
          that.$router.push({path: '/'})
        } else {
          var qstr = {
            whereinfo: " ownphone ='" + localStorage.getItem('username') + "'",
            limit: '',
            sortinfo: ''
          }
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/querylbi',
            method: 'post',
            data: qstr,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.length > 0) {
                that.branddata = res.data
              } else {
                that.branddata = []
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      editlbt (index, data) {
        var curselectdata = data[index]
        this.ifnewbrand = false
        this.vis_addbrandpanel = true
        this.editbranddata = curselectdata
        console.log(curselectdata)
        this.address_lbt = curselectdata.adurl
        this.lbttjindex = curselectdata.tjindex
        if (curselectdata.linktype === 0) {
          this.radiovalue = '1'
          this.showlbtlink = false
        } else if (curselectdata.linktype === 2) {
          this.radiovalue = '2'
          this.showlbtlink = true
          this.lbt_link = 'tab_video'
          this.address_video = curselectdata.hurl
        } else if (curselectdata.linktype === 3) {
          this.radiovalue = '2'
          this.showlbtlink = true
          this.lbt_link = 'tab_goodstype'
          var dataindex = that.gtypedatas.findIndex(d => d.id === curselectdata.goodstypeid)
          this.select_type = that.gtypedatas[dataindex].name
          this.selecttype = curselectdata.goodstypeid
          window.console.log('选取对象',that.gtypedatas[dataindex])
          setTimeout(() => {
            this.$refs.gt_tree_list.setCurrentNode(that.gtypedatas[dataindex])
          }, 0)
        } else if (curselectdata.linktype === 4) {
          this.radiovalue = '2'
          this.showlbtlink = true
          this.address_h5 = curselectdata.hurl
          this.lbt_link = 'tab_h5page'
        }
      },
      /* 删除轮播图 */
      dellbt (index, data) {
        var curselectdata = data[index]
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/dellbi',
          method: 'post',
          data: {
            id: curselectdata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.querybrand()
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      OnLCLBTResourceSuccess (res) {
        if (res.success) {
          this.address_lbt = res.data[0].osspath
        }
      },
      OnVideoResourceSuccess (res) {
        if (res.success) {
          this.address_video = res.data[0].osspath
        }
      },
      OnTypeNImgResourceSuccess (res) {
        this.address_type_img = res.data[0].osspath
      },
      linkchange () {
        if (this.radiovalue === '1') {
          this.showlbtlink = false
        } else if (this.radiovalue === '2') {
          this.showlbtlink = true
        }
      },
      typeselectchange (row) {
        console.log(row)
        this.selecttype = row
        this.select_type = row.name.String
      },
      savelbtinfo () {
        var lbtdata
        if (this.ifnewbrand) {
          if (this.radiovalue === '1') {
            lbtdata = {
              id: '',
              adurl: this.address_lbt,
              pos: that.brandpos,
              appid: '1',
              linktype: '0',
              hurl: '',
              goodstypeid: '0',
              goodsid: '0',
              tjindex: this.lbttjindex.toString(),
              cusid: that.khid.toString(),
              ownphone: localStorage.getItem('username')
            }
          } else if (this.radiovalue === '2') {
            if (this.lbt_link === 'tab_video') {
              lbtdata = {
                id: '',
                adurl: this.address_lbt,
                pos: that.brandpos,
                appid: '1',
                linktype: '2',
                hurl: that.address_video,
                goodstypeid: '0',
                goodsid: '0',
                tjindex: this.lbttjindex.toString(),
                cusid: that.khid.toString(),
                ownphone: localStorage.getItem('username')
              }
            } else if (this.lbt_link === 'tab_goodstype') {
              lbtdata = {
                id: '',
                adurl: this.address_lbt,
                pos: that.brandpos,
                hurl: '',
                goodstypeid: that.selecttype.toString(),
                goodsid: '0',
                appid: '1',
                linktype: '3',
                tjindex: this.lbttjindex.toString(),
                cusid: that.khid.toString(),
                ownphone: localStorage.getItem('username')
              }
            } else {
              lbtdata = {
                id: '',
                adurl: this.address_lbt,
                pos: that.brandpos,
                appid: '1',
                hurl: that.address_h5,
                goodstypeid: '0',
                goodsid: '0',
                linktype: '4',
                tjindex: this.lbttjindex.toString(),
                cusid: that.khid.toString(),
                ownphone: localStorage.getItem('username')
              }
            }
          }
        } else {
          if (this.radiovalue === '1') {
            lbtdata = {
              id: this.editbranddata.id.toString(),
              adurl: this.address_lbt,
              pos: that.brandpos,
              appid: '1',
              linktype: '0',
              hurl: '',
              goodstypeid: '0',
              goodsid: '0',
              tjindex: this.lbttjindex.toString(),
              cusid: that.khid.toString(),
              ownphone: localStorage.getItem('username')
            }
          } else if (this.radiovalue === '2') {
            if (this.lbt_link === 'tab_video') {
              lbtdata = {
                id: this.editbranddata.id.toString(),
                adurl: this.address_lbt,
                pos: that.brandpos,
                appid: '1',
                linktype: '2',
                hurl: that.address_video,
                goodstypeid: '0',
                goodsid: '0',
                tjindex: this.lbttjindex.toString(),
                cusid: that.khid.toString(),
                ownphone: localStorage.getItem('username')
              }
            } else if (this.lbt_link === 'tab_goodstype') {
              lbtdata = {
                id: this.editbranddata.id.toString(),
                adurl: this.address_lbt,
                pos: that.brandpos,
                hurl: '',
                goodstypeid: that.selecttype.toString(),
                goodsid: '0',
                appid: '1',
                linktype: '3',
                tjindex: this.lbttjindex.toString(),
                cusid: that.khid.toString(),
                ownphone: localStorage.getItem('username')
              }
            } else {
              lbtdata = {
                id: this.editbranddata.id.toString(),
                adurl: this.address_lbt,
                pos: that.brandpos,
                appid: '1',
                hurl: that.address_h5,
                goodstypeid: '0',
                goodsid: '0',
                linktype: '4',
                tjindex: this.lbttjindex.toString(),
                cusid: that.khid.toString(),
                ownphone: localStorage.getItem('username')
              }
            }
          }
        }
        console.log(lbtdata)
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addlbi',
          method: 'post',
          data: lbtdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '保存完毕'
              })
              that.querybrand()
            } else {
              that.$message({
                type: 'error',
                message: '保存失败'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      randomString (num) {
        let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
        let res = ''
        for (let i = 0; i < num; i++) {
          var id = Math.ceil(Math.random() * 35)
          res += chars[id]
        }
        return res
      },
      createOssClient () {
        return new Promise((resolve, reject) => {
          let client = new OSS({
            region: 'oss-cn-beijing',
            accessKeyId: 'LTAIK44bzZpLz0As',
            accessKeySecret: 'pWSiczyGrBXhnXIJ7Crj8GxNkkEzM0',
            bucket: 'wyzb1'
          })
          resolve(client)
        })
      },
      async fnUploadRequest (option) {
        var that = this
        let file = option.file
        const self = this
        return new Promise((resolve, reject) => {
          let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
          console.log(date)
          let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
          let randomStr = self.randomString(4)//  4位随机字符串
          let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
          console.log(dateTime)
          console.log(randomStr)
          console.log(extensionName)
          let fileName = that.selectpath + file.name // 文件名字（相对于根目录的路径 + 文件名）
          // 执行上传
          self.createOssClient().then(client => {
            // 异步上传,返回数据
            resolve({
              fileName: file.name,
              fileUrl: fileName
            })
            // 上传处理
            // 分片上传文件
            client.multipartUpload(fileName, file, {
              progress: function (p) {
                let e = {}
                e.percent = Math.floor(p * 100)
                // console.log('Progress: ' + p)
                option.onProgress(e)
                that.uppercent = e.percent
                console.log(e.percent)
              }
            }).then((val) => {
              if (val.res.statusCode === 200) {
                option.onSuccess(val)
                return val
              } else {
                option.onError('上传失败')
              }
            }, err => {
              option.onError('上传失败')
              reject(err)
            })
          }).catch(errinfo => {
          })
        })
      },
      async fnUploadSuccess (res, file, fileList) {
        console.log(res)
        if (res.res.status === 200) {
          var uppath = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
          console.log(uppath)
          console.log(this.upfiletype)
          if (this.upfiletype === 'image') {
            this.pagecontext = this.pagecontext + '<p><img src="' + uppath + '"></p>'
          } else {
            this.pagecontext = this.pagecontext + '<video class="videoinfo" id="videoinfo" src="' + uppath + '" controls="controls" loop="loop"> </video>'
          }
          console.log(this.pagecontext)
        }
        // TODO
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/control/BrandSet.vue